// Centralized CSRF token fetch & cache for SPA
import { toApiUrl } from './config/api';

let _csrfToken: string | null = null;
let _pending: Promise<string> | null = null;

async function fetchToken(): Promise<string> {
  // Some deployments mount role-specific routers without bootstrap pages.
  // Use the global public token first; role-specific endpoints can be protected
  // in production and a harmless 403 still appears as console noise.
  const candidates = ['/auth/csrf-token', '/reception/api/csrf'];
  for (const url of candidates) {
    try {
      const r = await fetch(toApiUrl(url), {
        credentials: 'include',
        headers: { Accept: 'application/json' },
      });
      if (!r.ok) continue;
      const d = await r.json();
      const t = (d && (d.csrf_token || d.token)) as string | undefined;
      if (t) return String(t);
    } catch {
      // Token fetch error
    }
  }
  return '';
}

export async function ensureCsrfToken(force = false): Promise<string> {
  if (!force && _csrfToken) return _csrfToken;
  if (_pending) return _pending;
  _pending = (async () => {
    const t = await fetchToken();
    _csrfToken = t;
    _pending = null;
    return t;
  })();
  return _pending;
}

export async function withCsrfInit(init: RequestInit = {}, force = false): Promise<RequestInit> {
  const token = await ensureCsrfToken(force);
  const headers = new Headers(init.headers || {});
  if (token) headers.set('X-CSRF-Token', token);
  return { ...init, headers };
}

export function getCachedCsrf(): string | null { return _csrfToken; }
/** Receive a rotated token from an authenticated account mutation. */
export function setCsrfToken(token: string): void { _csrfToken = token; }
